'use client';

import React, { useRef } from 'react';
import './style.scss';
// eslint-disable-next-line no-undef
const Loading = (): JSX.Element => {
  const container = useRef<HTMLDivElement>(null);

  return (
    <div ref={container} className='base-loading'>
      <div className='dot dot-a'></div>
      <div className='dot dot-b'></div>
      <div className='dot dot-c'></div>
    </div>
  );
};

export default Loading;
